module.exports = __webpack_public_path__ + "static/media/badar.9fce6880.ogg";